
import React, { useState } from 'react';
import { Box, Typography, TextField, IconButton, Modal, Button, CircularProgress } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import api from "../../api"
import { toast } from 'sonner';
import OtpModal from './OtpModalProfile';

const EditableEmailField = ({ initialEmail }) => {
  const [email] = useState(initialEmail);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tempEmail, setTempEmail] = useState(email);
  const [submitting, setSubmitting] = useState(false);
  const [submitOtp, setSubmitOtp] = useState(false);
  const [user, setUser] = useState({});
  const [otp, setOtp] = useState("");
  const token = JSON.parse(localStorage.getItem("token"))?.token;
  const [openOtpDialog, setOpenOtpDialog] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTempEmail(email);
  };
 
  const handleVerifyEmail = async (e) => {
    setSubmitting(true)
    e.preventDefault();
    try {
      const response = await api.post(`/users/update-email`,
        {
          newEmail: tempEmail,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success(response.data.message);
      setSubmitting(false)
      setIsModalOpen(false);
      setOpenOtpDialog(true)
    }
    catch (error) {
      toast.error(error.response.data.message);
      setSubmitting(false)
      console.error("Error profile:", error);
    }
  }

  const handleOtpSubmit = async (eOrOtp) => {
    let submittedOtp = otp; // Default to existing OTP state
  
    // Check if the first argument is an event
    if (eOrOtp && eOrOtp.preventDefault) {
      eOrOtp.preventDefault();
    } else {
      submittedOtp = eOrOtp; // If it's not an event, assume it's an OTP value
    }
  
    setSubmitOtp(true);
    try {
      const response = await api.post(`/users/verify-email`, {
        newEmail: tempEmail,
        otp: submittedOtp, // Use the correct OTP value
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      setUser(response.data.user);
      toast.success(response.data.message);
      localStorage.setItem("User", JSON.stringify(response.data.user));
      setSubmitOtp(false);
      window.location.reload();
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
      setSubmitOtp(false);
      console.error("Error profile:", error);
    }
  };
  
  

  const textFieldSx = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        backgroundColor: '#fff',
        '& fieldset': {
            borderColor: '#e0e0e0',
        },
        '&:hover fieldset': {
            borderColor: '#bdbdbd',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#1976d2',
        },
        '&.Mui-disabled': {
            backgroundColor: '#f0f0f0', // Darker background for disabled fields
        },
    },
    '& .MuiInputBase-input': {
        padding: '10px 14px',
    },
    '& .Mui-disabled .MuiInputBase-input': {
        color: '#757575', // Optional: Adjust text color for better contrast
    },
};


  return (
    <Box>
      <Typography sx={{ mb: 1, fontWeight: 600, fontSize: '0.875rem' }}>
        Email
      </Typography>
      <TextField
        disabled
        fullWidth
        value={email}
        variant="outlined"
        sx={textFieldSx}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <IconButton onClick={handleOpenModal} edge="end">
              <EditIcon fontSize="small" />
            </IconButton>
          ),
        }}
      />
        
    {/* Verify Email */}
    <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        aria-labelledby="edit-email-modal"
        aria-describedby="modal-to-edit-email"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 480,
          bgcolor: 'background.paper',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          borderRadius: '16px',
          p: 4,
          outline: 'none',
        }}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,
          }}>
            <Typography id="edit-email-modal" variant="h6" component="h6" sx={{ fontWeight: 700, fontSize: '1.25rem' }}>
              Edit Email Address
            </Typography>
            <IconButton onClick={handleCloseModal} size="small" sx={{ p: 0 }}>
              <CloseIcon size={24} />
            </IconButton>
          </Box>
          <Box>
          <Typography sx={{ mb: 1, fontWeight: 600, fontSize: '0.875rem' }}>
            Change Email Address
            </Typography>
          <TextField
            fullWidth
            value={tempEmail}
            onChange={(e) => setTempEmail(e.target.value)}
            variant="outlined"
            placeholder="Enter your new email"
            sx={{ ...textFieldSx}}
          />
          </Box>
         <Button
            variant="contained"
            onClick={handleVerifyEmail}
            fullWidth
            disabled={submitting} // Disables the button while loading
            sx={{
              bgcolor: "#010320",
              color: "#FFF",
              mt: 3,
              textTransform: "none",
              borderRadius: "8px",
              padding: "10px 16px",
              "&:hover": {
                bgcolor: "#010320",
              },
              "&.Mui-disabled": {
                bgcolor: "#e0e0e0",
                color: "#9e9e9e",
              },
            }}
          >
            {submitting ? 
            <CircularProgress
              size={24}
              sx={{
                  color: "#FFF",
              }}
          /> : "Verify Email"}
          </Button>
        </Box>
      </Modal>

      <OtpModal
        isOpen={openOtpDialog}
        onClose={() => setOpenOtpDialog(false)}
        onVerify={handleOtpSubmit}
        otp={otp}
        setOtp={setOtp}
        loading={submitOtp}
        newEmail={tempEmail}
      /> 
      
    </Box>
  );
};

export default EditableEmailField;